import { jsx as _jsx } from "react/jsx-runtime";
import { useAccreditations } from '@src/hooks/useAccreditations';
import { MuiMultiSelect, useLocale } from 'pe-core-frontend';
export const AccreditationsPicker = ({ className, label, accreditationIds, errors, onChange, disabled, clientId, disablePortal = false, }) => {
    const { t } = useLocale();
    const { accreditationsOptions } = useAccreditations({ clientId });
    const handleChange = (e) => {
        onChange(e.selection.map(s => s.value));
    };
    return (_jsx(MuiMultiSelect, { className: className, label: label || t('Groups'), options: accreditationsOptions, value: accreditationIds, onChange: handleChange, errors: errors, disabled: disabled, disablePortal: disablePortal }));
};
